import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Filter from "../../components/Filter";
import Introduction from "../../components/Introduction";
import DefaultPage from "../DefaultPage/DefaultPage";
import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import "./GalleryPage.css";
import FolderCard from "./FolderCard";
import Loader from "../../components/Loader";

const GalleryPage = () => {
  //definice stavů
  const [filterParameters, setFilterParameters] = useState("");

  //stavy pro uchovani predchozi zvolene kategorie
  const [filterSearchTerm, setFilterSearchTerm] = useState("");
  const [filterSelectedCategory, setFilterSelectedCategory] = useState("");

  //fetch stránky (uvod)
  const {
    loading: loadingIntroduction,
    error: errorIntroduction,
    data: dataIntroduction,
  } = useFetch(`${config.api}/api/gallery-page?populate=background`);

  //fetch kategorii pro filtr
  const {
    loading: loadingCategories,
    error: errorCategories,
    data: dataCategories,
  } = useFetch(`${config.api}/api/gallery-categories`);

  //fetch dokumentů (populate pro jmena kategorii a media[fotografie])
  const { loading, error, data } = useFetch(
    `${config.api}/api/galeries?populate[0]=galleryCategory&populate[1]=thumbnail${filterParameters}&sort[0]=date:desc`
  );

  // možné stavy při/po fetchi
  if (loadingIntroduction) return <Loader />;
  if (errorIntroduction)
    return <DefaultPage message="Chyba při načítání úvodu" />;
  if (!dataIntroduction || !dataIntroduction.data)
    return <DefaultPage message="Chyba při načítání úvodu" />;

  if (loadingCategories) return <Loader />;
  if (errorCategories)
    return <DefaultPage message="Chyba při načítání kategorií" />;
  if (!dataCategories || !dataCategories.data)
    return <DefaultPage message="Chyba při načítání kategorií" />;

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání fotografií" />;

  if (!data || !data.data) return <DefaultPage message="Žádné fotografie" />;

  //? console.log(dataCategories.data);
  //? console.log(data.data);

  //metoda filtru - po submitu tlacitkem se předají stavy textu a kategorie do url pro strapi filtr
  const handleFilterSubmit = ({ searchTerm, selectedCategory }) => {
    let parametersURL = "&";
    if (searchTerm !== "") {
      parametersURL += `filters[name][$contains]=${searchTerm}`;
    }
    if (searchTerm !== "" && selectedCategory !== "") {
      parametersURL += `&`;
    }
    if (selectedCategory !== "") {
      parametersURL += `filters[galleryCategory][name][$eq]=${selectedCategory}`;
    }

    setFilterSearchTerm(searchTerm);
    setFilterSelectedCategory(selectedCategory);

    //? test
    //? console.log(searchTerm, selectedCategory);
    setFilterParameters(parametersURL);
  };

  // rekonstrukce strapi dat kategorii do jednodussiho pole
  const categoriesNames = dataCategories.data.map((categories) => ({
    id: categories.id,
    category: categories.name,
  }));

  //změna titulku stránky v prohlížeči
  document.title = dataIntroduction.data.title;

  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction
        title={dataIntroduction.data.title}
        text={dataIntroduction.data.description}
        image={dataIntroduction.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background d-flex justify-content-around flex-wrap pb-5">
          <div className="d-flex container justify-content-center">
            <Filter
              categories={categoriesNames}
              onFilterSubmit={handleFilterSubmit}
              selectedCategory={filterSelectedCategory}
              searchTerm={filterSearchTerm}
            />
          </div>
          {/* v url se musi zadat složka, vytvorena v assetech ve strapi */}
          {data.data.map((gallery, index) => (
            <FolderCard
              key={index}
              name={gallery.name}
              category={gallery?.galleryCategory?.name}
              thumbnail={gallery.thumbnail.url}
              date={gallery.date}
              url={`/fotogalerie/${gallery.documentId}`}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default GalleryPage;
